const signalr = require("@aspnet/signalr")
import mqtt from 'mqtt'
import Vue from 'vue'
import axios from 'axios'

global.fetch = require("node-fetch")
let https = null



/**
 * @class
 * Class which need to perfomr network requests
 */
export class Network {
    /**
     * @constructor
     */
    constructor(noHttps){
        this._eventBus = new Vue()
        if(noHttps==true){
            https = require('http')
        }else{
            https = require('https')
        }
        this.HTTP = new HTTP()
        this.MQTT = new MQTT(this._eventBus)
        this.SignalR = new SignalR(this._eventBus)
    }

    get eventBus(){
        return this._eventBus
    }

    /** 
     * @method SendHTTPSigV4Request Perform a request 
     * @param {HTTPRequestDescriptor} requestDescriptor HTTP request descriptor
     * @param {function} dataConverter Network data converter function
     * @returns {Promise} 
     */ 
    SendRequest(requestDescriptor){
        let promiseRequest = null
        switch(requestDescriptor.protocol.toLowerCase()){
            case "http":
                promiseRequest = new Promise(
                        (resolve,reject)=>{
                            let action = requestDescriptor.method
                            let url = requestDescriptor.url
                            let path = requestDescriptor.path
                            let queryString =  requestDescriptor.queryString
                            let body = requestDescriptor.body
                            let headers = requestDescriptor.headers
                            let streaming = requestDescriptor.streaming
                            // if((typeof body)=="object")
                            //     body = JSON.stringify(body)
                            
                            let promise = null
                            switch(action){
                                case "GET":
                                    promise = this.HTTP.Get(url,headers,path,queryString,streaming)
                                    break
                                case "POST":
                                    promise = this.HTTP.Post(url,headers,path,queryString,body,streaming)
                                    break
                                case "PUT":
                                    promise = this.HTTP.Put(url,headers,path,queryString,body,streaming)
                                    break
                                case "DELETE":
                                    promise = this.HTTP.Delete(url,headers,path,queryString,streaming)
                                    break
                                case "PATCH":
                                    promise = this.HTTP.Patch(url,headers,path,queryString,undefined,streaming)
                                    break              
                                default: 
                                    reject()
                                    return  
                            }
                            promise
                                .then((data)=>{
                                    try{
                                        resolve((requestDescriptor.deserializer)?requestDescriptor.deserializer(data.data):data.data)
                                    }catch(ex){
                                        reject(ex)
                                    }
                                })
                                .catch((err)=>{
                                    reject(err)
                                })
                        }
                    )
                    break
                case "mqtt":
                        promiseRequest = new Promise(
                            (resolve)=>{
                                let action = requestDescriptor.method
                                let url = requestDescriptor.url
                                let path = requestDescriptor.path
                                switch(action){
                                    case "CONNECT":
                                        this.MQTT.Connect(
                                            url
                                        ).then((data)=>resolve(data))
                                        break
                                    case "SUBSCRIBE":
                                        this.MQTT.Subscribe(path).then((data)=>resolve(data))
                                        break                                 
                                    case "CLOSE":
                                        this.MQTT.Close()
                                            .then((data)=>resolve(data))                                        
                                        break
                                }
                            }
                        )
                        break
                case "signalr":
                        promiseRequest = new Promise(
                            (resolve)=>{
                                let action = requestDescriptor.method
                                let url = requestDescriptor.url
                                let path = requestDescriptor.path
                                let args = requestDescriptor.body
                                switch(action){
                                    case "CONNECT":
                                        this.SignalR.Connect(
                                            url+path,
                                            requestDescriptor.headers.tokenFactory
                                        ).then((data)=>resolve(data))
                                        break
                                    case "INVOKE":
                                        this.SignalR.Invoke(
                                            path,
                                            args
                                        ).then((data)=>resolve(data))
                                        break
                                    case "RECEIVE":
                                        this.SignalR.Receive(path).then((data)=>resolve(data))
                                        break                                       
                                    case "CLOSE":
                                        this.SignalR.Close()
                                            .then((data)=>resolve(data))                                        
                                        break
                                }
                            }
                        )
                        break
                default:
                        throw "Network protocol unknown"
        }
        
        return promiseRequest
    }

    

}


/**
 * @class
 * Class which need to perfomr HTTP request
 */
export class HTTP {
    /**
     * @constructor
     */
    constructor(){
    }

    /**
     * @method Get Perform a GET 
     * @param {string} url URL with protocol
     * @param {object} headers HTTP Headers
     * @param {string} path Path
     * @param {string} queryString Query string
     * @returns {Promise} 
     */ 
    async Get(url,headers,path,queryString,streaming){
        return this.Generic('GET',url,headers,path,queryString,"",streaming)
    }

    /** 
     * @method Post Perform a POST request 
     * @param {string} url URL with protocol
     * @param {object} headers HTTP Headers
     * @param {string} queryString Query string
     * @param {string} body Body
     * @returns {Promise} 
     */ 
    async Post(url,headers,path,queryString,body,streaming){
        return this.Generic('POST',url,headers,path,queryString,body,streaming)
    }

    /**
     * @method Put Perform a PUT request 
     * @param {string} url URL with protocol
     * @param {object} headers HTTP Headers
     * @param {string} queryString Query string
     * @param {string} body Body
     * @returns {Promise} 
     */ 
    async Put(url,headers,path,queryString,body,streaming){
        return this.Generic('PUT',url,headers,path,queryString,body,streaming)
    }

    /**
     * @method Delete Perform a DELETE request
     * @param {string} url URL with protocol
     * @param {object} headers HTTP Headers
     * @param {string} queryString Query string
     * @returns {Promise} 
     */ 
    async Delete(url,headers,path,queryString,streaming){
        return this.Generic('DELETE',url,headers,path,queryString,"",streaming)
    }  

    /**
     * @method Patch Perform a DELETE request
     * @param {string} url URL with protocol
     * @param {object} headers HTTP Headers
     * @param {string} queryString Query string
     * @returns {Promise} 
     */ 
    async Patch(url,headers,path,queryString,streaming){
        return this.Generic('PATCH',url,headers,path,queryString,"",streaming)
    } 

    /**
     * @private
     * @method Generic
     */ 
    Generic(apiMethod,apiHost,apiHeaders,apiEndpoint,apiQueryString,data,streaming){
        if((typeof apiQueryString)=="string"){
            if(apiQueryString.length>0)
                apiQueryString="?"+apiQueryString
        }else
            apiQueryString = ""
        return axios.request({
            method: apiMethod.toLowerCase(),
            url: 'https://'+apiHost+apiEndpoint+apiQueryString,
            headers: apiHeaders,
            data:data,
            responseType: streaming ? 'blob' : undefined
        })
    }
}

/** 
 * @class
 * MQTT client 
 */
export class MQTT {

    /**
     * @constructor
     */
    constructor(eventBus){
        this.client = null
        this.eventBus = eventBus
    }

    /** 
     * @method Connect Connect MQTT client 
     * @param {string} URL Complete URL to connect to
    */
    Connect(url){
        return new Promise(
            (resolve,reject)=>{
                try{
                    this.client  = mqtt.connect(url)
                    this.client.on('connect', function () {
                        resolve("connected to "+url)
                    }.bind(this))
                    this.client.on('disconnect', ()=> this.eventBus.$emit("disconnect"))
                    this.client.on('close', ()=>this.eventBus.$emit("closed"))
                }catch(ex){
                    reject(ex)
                }
            })
    }

    /** 
     * @method Subscribe Subscribe to a topic
     * @param {string} topic Target topic
     * @param {function} messageCallback Callback called at each message received on topic
    */
    Subscribe(topic){
        return new Promise(
            (resolve,reject)=>{
                try{
                    this.client.subscribe(
                        topic, 
                        (err) => {
                        if (err)
                            reject(err)
                        else{
                            this.client.on('message', 
                                (rxTopic, rxMessage) => {
                                    if(topic==rxTopic)
                                        this.eventBus.$emit(
                                            "message",
                                            {
                                                metadata:rxTopic,
                                                payload:rxMessage.toString('utf8')
                                            }
                                        )
                                })
                            resolve("subscribed to "+topic)
                        }
                    })
                }catch(ex){
                    reject(ex)
                }
            })
    }

    /** 
     * @method Connect Force closing MQTT connection 
    */
    Close(){
        return new Promise(
            (resolve,reject)=>{
                this.client.end(true,
                    (err)=>{
                        if(err)
                            reject(err)
                        else
                            resolve("closed")
                })
            })        
    }
}


/** 
 * @class
 * SignalR client 
 */
export class SignalR {

    /**
     * @constructor
     */
    constructor(eventBus){
        this.connection = null
        this.eventBus = eventBus
        this.forcedClosing = false
    }

    /** 
     * @method Connect Connect client 
     * @param {string} URL Complete URL to connect to
    */
    Connect(url,authTokenFactory){
        this.forcedClosing = false
        return new Promise(
            (resolve)=>{
                this.connection = 
                    new signalr.HubConnectionBuilder()
                        .withUrl(url, { accessTokenFactory:authTokenFactory})
                        .configureLogging(signalr.LogLevel.Information)
                        .build()
                
                this.connection.start()
                    .then( ()=>{
                        resolve()
                    })
                
                this.connection.onclose(
                    ()=>{
                        if(this.forcedClosing==false){
                            let methods = this.connection.methods
                            let callbacks = this.connection.callbacks
                            let closedCallbacks = this.connection.closedCallbacks
                            this.connection = 
                                new signalr.HubConnectionBuilder()
                                    .withUrl(url, { accessTokenFactory:authTokenFactory})
                                    .configureLogging(signalr.LogLevel.Information)
                                    .build()       
                            
                            this.connection.methods = methods
                            this.connection.closedCallbacks = closedCallbacks
                            this.connection.callbacks = callbacks
                            
                            this.connection.start()
                                .then( ()=>{
                                    resolve()
                                })                
                        }else{
                            this.eventBus.$emit("closed")
                        }
                    }
                )
            }
        )

    }
    /** 
     * @method Subscribe Subscribe connection 
     * 
    */
    Invoke(topic,args){
        return new Promise(
            (resolve) => 
                this.connection.invoke(topic, args)
                .then(data=>resolve(data))
        )
    }

    /** 
     * @method Receive Subscribe connection 
    */
    Receive(topic){
        return new Promise(
            (resolve)=>{
                this.connection.on(
                    topic, 
                    (message) => {
                        this.eventBus.$emit("message",message)
                    }
                )
                resolve()
            }
        )

    }

    /** 
     * @method Connect Force closing connection 
    */
    Close(){
        return new Promise(
            function(resolve){
                this.forcedClosing = true
                this.connection.stop()
                resolve()
            }.bind(this))        
    }
}